import React from "react";
import {
  milestoneData,
  milestoneImgDataOne,
  milestoneImgDataTwo,
} from "../../../utils/v2";
import { motion } from "framer-motion";

const Milestone = () => {
  const containerVariant = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.15 },
    },
  };

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={containerVariant}
      className="w-full bg-SCA-White py-16"
    >
      <div className="w-[90%] max-w-[1239px] mx-auto">
        <motion.article
          variants={fadeUpVariant}
          className="text-center w-full text-secondary-main-black max-w-[768px] mx-auto"
        >
          <h3 className="section-header 2md:leading-[82px] hero-text max-w-[474px] w-full mx-auto">
            Milestones of{" "}
            <span className="text-primary-main-pink">Innovation</span>
          </h3>
          <p className="mt-4 text-center description-text">
            Eight pivotal moments that transformed our vision into a movement,
            empowering women across Africa to lead in technology.
          </p>
        </motion.article>

        <motion.section
          variants={containerVariant}
          className="mt-10 w-full flex gap-10 xl:justify-center py-4"
        >
          <motion.div
            variants={fadeUpVariant}
            className="hidden xl:block w-full"
          >
            {milestoneImgDataOne.map((milestone, i) => (
              <div
                className={`w-full max-w-[335px] h-[224px] rounded-2xl flex items-end px-3  py-7 bg-no-repeat bg-cover last:mb-0 mb-[120px] ${milestone.image}`}
                key={i}
                // style={{ backgroundImage: `url(${image})` }}
              >
                <div className="w-full">
                  <h4 className="w-auto min-w-[42px] inline-flex bg-[rgba(233,225,230,1)] py-1 px-2 rounded-3xl justify-center items-center text-primary-main-pink text-xs font-normal m-0 leading-none">
                    {milestone.yearRange}
                  </h4>

                  <p className="font-medium capitalize text-white text-xl mt-2">
                    {milestone.title}
                  </p>
                </div>
              </div>
            ))}
          </motion.div>
          <motion.div variants={containerVariant} className="w-full">
            {milestoneData.map(
              ({ year, title, subText, yearRange, range }, i) => (
                <div className="flex gap-3 items-stretch mb-6" key={i}>
                  <h4
                    className={`text-primary-main-pink text-2xl font-semibold !my-0`}
                  >
                    {range ? (
                      <>
                        <span>{yearRange.slice(0, 4)}</span>
                        <br />
                        <span>{yearRange.slice(5)}</span>
                      </>
                    ) : (
                      year
                    )}
                  </h4>

                  <div className="flex flex-col gap-2 items-center  ">
                    <span className="inline-block w-[24px] h-[24px] rounded-full border border-primary-main-pink bg-[rgba(254,254,254,1)]"></span>
                    <span
                      className={`block w-0 border border-primary-main-pink flex-1 ${
                        i === milestoneData.length - 1 ? "opacity-0" : ""
                      }`}
                    ></span>
                  </div>

                  <article className="flex flex-col gap-2">
                    <h3 className="!my-0 !text-2xl text-primary-main-pink capitalize font-semibold">
                      {title}
                    </h3>

                    <p className="!text-base text-[rgba(51,51,51,1)]  font-normal xl:max-w-[280px]">
                      {subText}
                    </p>
                  </article>
                </div>
              )
            )}
          </motion.div>
          <motion.div
            variants={fadeUpVariant}
            className="hidden md:block w-full"
          >
            {milestoneImgDataTwo.map((milestone, i) => (
              <motion.div
                variants={fadeUpVariant}
                className={`w-full max-w-[335px] h-[224px] rounded-2xl flex items-end px-3  py-7  bg-no-repeat bg-cover last:mb-0 mb-[120px] ${milestone.image}`}
                key={i}
              >
                <div className="w-full">
                  <h4 className="min-w-[42px] inline-flex w-auto bg-[rgba(233,225,230,1)] py-1 px-2 rounded-3xl justify-center items-center text-primary-main-pink  text-xs font-normal m-0 leading-none">
                    {milestone.yearRange}
                  </h4>

                  <p className="font-medium capitalize text-white text-xl mt-2">
                    {milestone.title}
                  </p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.section>
      </div>
    </motion.section>
  );
};

export default Milestone;
